/**
 * Created by dev on 6/24/22.
 */
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name stationFlightHandling.controller:StationFlightHandlingPopUpCtrl
   *
   * @description
   *
   */
  angular
    .module('stationFlightHandling')
    .controller('StationFlightHandlingPopUpCtrl', StationFlightHandlingPopUpCtrl);

  function StationFlightHandlingPopUpCtrl(modalParams, MessageService, $uibModalInstance, StationFlightHandlingService, $compile, $scope, $timeout, PopupManager, CommonMasterData) {
    var vm = this;
    vm.ctrlName = 'StationFlightHandlingPopUpCtrl';
    vm.modalParam = modalParams;

    vm.flightInfoModel = {
      flightDate: (modalParams.flightDate === null) ? null : modalParams.flightDate.split(" ")[0],
      flightNo: modalParams.flightNumber,
      acReg: modalParams.aircraftRegName,
      acType: modalParams.modelNumber,
      origin: modalParams.origin,
      destination: modalParams.destination,
      cptName: modalParams.pilotName,
      staffOnDuty: modalParams.staffOnDuty,
      thirdPartyGroundHandler:modalParams.thirdPartyGroundHandler,
      stdDate: (modalParams.originalEstDepartureDate === null) ? null : modalParams.originalEstDepartureDate.split(" ")[0],
      stdTime: modalParams.originalEstDepartureDateTime,

      atdDate: (modalParams.actDepartureDate === null) ? null : modalParams.actDepartureDate.split(" ")[0],
      atdTime: modalParams.actDepartureDateTime,

      rstdDate: (modalParams.estDepartureDate === null) ? null : modalParams.estDepartureDate.split(" ")[0],
      rstdTime: modalParams.estDepartureDateTime,

      rstaDate: (modalParams.estArrivalDate === null) ? null : modalParams.estArrivalDate.split(" ")[0],
      rstaTime: modalParams.estArrivalDateTime,

      staDate: (modalParams.originalEstArrivalDate === null) ? null : modalParams.originalEstArrivalDate.split(" ")[0],
      staTime: modalParams.originalEstArrivalDateTime,

      ataDate: (modalParams.actArrivalDate === null) ? null : modalParams.actArrivalDate.split(" ")[0],
      ataTime: modalParams.actArrivalDateTime,

      groundTime:  parseInt(modalParams.groundTime),
      bayGate: modalParams.gate,
      delays: modalParams.delay,
      totalDelay: modalParams.totalDelay,
      remarks: modalParams.remarks,
      paxAdult: modalParams.paxAdult,
      paxChild: modalParams.paxChild,
      paxInfant: modalParams.paxInfant,
      actAdult: modalParams.actAdult,
      actChild: modalParams.actChild,
      actInfant: modalParams.actInfant,

      prevFltOriginalEstArrivalDate: (modalParams.prevFltOriginalEstArrivalDateTime === null) ? null : modalParams.prevFltOriginalEstArrivalDateTime.split(" ")[0],
      prevFltEstArrivalDate: (modalParams.prevFltEstArrivalDate === null) ? null : modalParams.prevFltEstArrivalDate.split(" ")[0],
      prevFltActArrivalDate: (modalParams.prevFltActArrivalDate === null) ? null : modalParams.prevFltActArrivalDate.split(" ")[0],
      prevFltOriginalEstArrivalTime: (modalParams.prevFltOriginalEstArrivalDateTime === null) ? null : modalParams.prevFltOriginalEstArrivalDateTime.split(" ")[1],
      prevFltEstArrivalTime: (modalParams.prevFltEstArrivalDate === null) ? null : modalParams.prevFltEstArrivalDate.split(" ")[1],
      prevFltActArrivalTime: (modalParams.prevFltActArrivalDate === null) ? null : modalParams.prevFltActArrivalDate.split(" ")[1],
      prevFltFltNo: modalParams.prevFltNumber


    };

    vm.flightHandlingModel = {
      lastPasDisembarked: modalParams.lastPaxDissEmbarked,
      cleaningStart: modalParams.cleaningStart,
      CleaningEnd: modalParams.cleaningEnd,
      cockpitCrewReporting: modalParams.cockpitCrewReporting,
      cabinCrewReporting: modalParams.cabinCrewReporting,
      boardingClearance: modalParams.boardingClearance,
      firstPaxBoarded: modalParams.firstPaxBrd,
      lastPaxBoarded: modalParams.lastPaxBrd,
      doorsClosed: modalParams.doorClosed,
      holdsClosed: modalParams.holdsClosed,
      wheelChairArrival: modalParams.wchrArrival,
      medlArrival: parseInt(modalParams.medLArrival),
      medLDeparture: parseInt(modalParams.medLDeparture),
      cabinCleaning: setYesNoDropDownValuesOnload(modalParams.cabinCleaning),
      waterService: setYesNoDropDownValuesOnload(modalParams.waterSvc),
      toiletService: setYesNoDropDownValuesOnload(modalParams.toiletSvc),
      towing: (modalParams.towing === null) ? {Val: "No"} : setYesNoDropDownValuesOnload(modalParams.towing),
      gpu: setYesNoDropDownValuesOnload(modalParams.gpu),
      asu: setYesNoDropDownValuesOnload(modalParams.asu),
      acu: setYesNoDropDownValuesOnload(modalParams.acu),
      aerobridge: setYesNoDropDownValuesOnload(modalParams.aeroBridge),
      fireBirgade: setYesNoDropDownValuesOnload(modalParams.fireBrigade),
      engTechnical: setYesNoDropDownValuesOnload(modalParams.engTecSvc),
      deIcing: setYesNoDropDownValuesOnload(modalParams.deicing),
      paxBus: setYesNoDropDownValuesOnload(modalParams.paxBus),
      paxSteps: setYesNoDropDownValuesOnload(modalParams.paxSteps),
      additionalComment: modalParams.additionalSvcComment
    };

    vm.paxHandlingModel = {
      goShowAdultChild: parseInt(modalParams.goShowAdultChild),
      goShowAmountAdultChild: modalParams.goShowAdultChildAmt,
      goShowInfant: modalParams.goShowInfra,
      goShowAmountInfant: modalParams.goShowInfraAmt,
      totalGoShowAmount: modalParams.totalGoShowAmount,
      arrivalPax: modalParams.arrivalPax,
      arrivalCargo: modalParams.arrivalCargoKgs,
      departureCargo: modalParams.departureCargoKgs,
      totalAcceptedOB: modalParams.totalAcceptedOnBoard,
      infantCount: modalParams.infCount,
      dnbOverbooking: modalParams.bnbOverBooking,
      gateNoShow: modalParams.gateNoShow,
      visaChangePax: modalParams.visaChangePax,
      ebVoucherIssued: modalParams.ebVoucherIssued === null ? 0 : modalParams.ebVoucherIssued,
      gateHandbagCollection: modalParams.gateHandbagCollection === null ? 0 : modalParams.gateHandbagCollection,
      ebWeight: modalParams.ebWeightKg,
      ebRevenue: modalParams.ebRevenue,
      AdditionalBagRevenue: modalParams.addBagRevenue,
      ebAdditionalBagServiceCharge: modalParams.ebAddSrvCharge,
      ebtTotalAmount: modalParams.ebtTotal,
      wchrDeparture: modalParams.wchrDeparture,
      whcrAmount: modalParams.wchrAmount,
      seatS: parseInt(modalParams.seat),
      seatAmt: parseInt(modalParams.seatsAmount),
      seatsPnrName: modalParams.seatsPnrName,
      acceptedTvLed: modalParams.acptTvLed,
      tvLedAmount: modalParams.tvLedAmount,
      totalAncillary: modalParams.totalAncillary,
      pendingBalance: modalParams.pendingBalance,
      counterRefusalCount: parseInt(modalParams.counterRefusal),
      norecCount: parseInt(modalParams.noRecCount),
      goShowRef: modalParams.goShowRef,
      seatRef: modalParams.seatRef,
      counterRefusalRef: modalParams.counterRefusalRef,
      norecRef: modalParams.norecRef,
      noOfCodesharePax: parseInt(modalParams.noOfCodesharePax),
      remarks: modalParams.remarksPax

    };

    vm.addlInfo = {
      bmeService: setYesNoDropDownValuesOnload(modalParams.bmeService),
      lbBaggagePCS: parseInt(modalParams.lbBaggagePCS),
      lbBaggageWeight: parseFloat(modalParams.lbBaggageWeight),
      lbBaggageReason: modalParams.lbBaggageReason,
      ovszdBaggage: parseInt(modalParams.ovszdBaggage),
      sportEquipCount: parseInt(modalParams.sportEquipCount),
      sportEquipDesc: modalParams.sportEquipDesc,
      INADPax: modalParams.inadPax,
      INADPaxCost: modalParams.paxCost,
      fine: setYesNoDropDownValuesOnload(modalParams.fine)
    };

    vm.auditLog = [];

//form names
    vm.flightInfoModelForm = "form1";
    vm.flightHandlingModelForm = "form2";
    vm.paxHandlingModelForm = "form3";
    vm.AdditionalInfo = "form4";


    vm.samplMenuItems = [{label: "value1"}, {label: "value2"}, {label: "value3"}];

    vm.yesNo = [{Val: "Yes"}, {Val: "No"}];

    if ((modalParams.delay1Code && modalParams.delay1Code.trim() !== "") ||
      (modalParams.delay2Code && modalParams.delay2Code.trim() !== "") ||
      (modalParams.delay3Code && modalParams.delay3Code.trim() !== "") ||
      (modalParams.delay4Code && modalParams.delay4Code.trim() !== "")
    ) {
      vm.Delays = [
        {
          "delayCode": modalParams.delay1Code,
          "delayMin": modalParams.delay1,
          "flightDelayCode": modalParams.flightDelay1Code,
          "flightDelayMin": modalParams.flightDelay1
        },
        {
          "delayCode": modalParams.delay2Code,
          "delayMin": modalParams.delay2,
          "flightDelayCode": modalParams.flightDelay2Code,
          "flightDelayMin": modalParams.flightDelay2
        },
        {
          "delayCode": modalParams.delay3Code,
          "delayMin": modalParams.delay3,
          "flightDelayCode": modalParams.flightDelay3Code,
          "flightDelayMin": modalParams.flightDelay3
        },
        {
          "delayCode": modalParams.delay4Code,
          "delayMin": modalParams.delay4,
          "flightDelayCode": modalParams.flightDelay4Code,
          "flightDelayMin": modalParams.flightDelay4
        }];
    } else {
      vm.Delays = [
        {
          "delayCode": modalParams.flightDelay1Code,
          "delayMin": modalParams.flightDelay1,
          "flightDelayCode": modalParams.flightDelay1Code,
          "flightDelayMin": modalParams.flightDelay1
        },
        {
          "delayCode": modalParams.flightDelay2Code,
          "delayMin": modalParams.flightDelay2,
          "flightDelayCode": modalParams.flightDelay2Code,
          "flightDelayMin": modalParams.flightDelay2
        },
        {
          "delayCode": modalParams.flightDelay3Code,
          "delayMin": modalParams.flightDelay3,
          "flightDelayCode": modalParams.flightDelay3Code,
          "flightDelayMin": modalParams.flightDelay3
        },
        {
          "delayCode": modalParams.flightDelay4Code,
          "delayMin": modalParams.flightDelay4,
          "flightDelayCode": modalParams.flightDelay4Code,
          "flightDelayMin": modalParams.flightDelay4
        }];
    }

    vm.delayCodeDetails = [];

    calTotalDelay();
    vm.paxtable1 = [];
    vm.paxtable2 = [];
    vm.paxtable3 = [];
    vm.paxtable4 = [];

    vm.enablePaxTable1AddBtn = true;
    vm.enablePaxTable2AddBtn = true;
    vm.enablePaxTable3AddBtn = true;
    vm.enablePaxTable4AddBtn = true;


    //functions area

    genarateFieldsForPaxTables(0);
    loadDelayCodeDetails();
    loadAuditData();


    //functions Area end


    //close PopUp
    vm.closePopUp = function () {
      console.log("Close Pop up");
      PopupManager.closeModal('STATION_FLIGHT_HANDLING_POPUP', null, null);
    };

    var delayCodeObj = function () {
      var delay = {"delayCode": '', "delayMin": ""};
      return delay;
    };

    vm.addNewdelay = function () {
      var delayObj = delayCodeObj();
      delayObj.departureOrArrival = "dep";
      vm.Delays.push(delayObj);

    };

    function setYesNoDropDownValuesOnload(value) {
      if (value === 'Y' || value === "Y ") {
        return {Val: "Yes"};
      } else if (value === 'N' || value === "N ") {
        return {Val: "No"};
      } else {
        return null;
      }
    }

    vm.setYesNoDropDownValue = function (value) {
      console.log("On Change in drop down:" + value);
      if (value === 'Y' || value === "Y ") {
        return {Val: "Yes"};
      } else if (value === 'N' || value === "N ") {
        return {Val: "No"};
      } else {
        return null;
      }
    }

    function validateFields() {
      if (vm.paxHandlingModel.ebWeight > 10000) {
        return false;
      }
      if (vm.paxHandlingModel.ebVoucherIssued > 999) {
        return false;
      }
      if (vm.paxHandlingModel.gateHandbagCollection > 999) {
        return false;
      }
      return true
    }

    function validateMovementInfo() {
      //validate registration
      if (vm.flightInfoModel.rstdDate === '' || vm.flightInfoModel.rstdTime === '') {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_32);
        return false;
      } else if (vm.flightInfoModel.rstaDate === '' || vm.flightInfoModel.rstaTime === '') {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_33);
        return false;
      }

      return validMovementInfoDateTimeFormat();
    }

    function validMovementInfoDateTimeFormat() {
      var rstdDate = vm.flightInfoModel.rstdDate;
      var rstdTime = vm.flightInfoModel.rstdTime;
      var rstaDate = vm.flightInfoModel.rstaDate;
      var rstaTime = vm.flightInfoModel.rstaTime;

      if ((!!rstdDate && !dateValidDate(rstdDate)) || (!!rstdTime && !timeValidate(rstdTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_5);
        return false;
      }
      else if ((!!rstaDate && !dateValidDate(rstaDate)) || (!!rstaTime && !timeValidate(rstaTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_6);
        return false;
      }
      else {
        return validDelayCodes();
      }
    }


    function validDelayCodes() {

      var isValid = false;
      for (var i = 0; i < vm.Delays.length; i++) {
        if (vm.Delays[i].delayCode === " ") {
          vm.Delays[i].delayCode = "";
        }
        if ((vm.Delays[i].delayCode != "" && vm.Delays[i].delayCode != undefined && vm.Delays[i].delayMin === "")
          || ((vm.Delays[i].delayCode === "" || vm.Delays[i].delayCode == undefined) && vm.Delays[i].delayMin != "")) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_14_D);
          isValid = false;
          break;

        }
        else {
          isValid = true;
        }
      }

      if (isValid) {
        return validDepDelay()
      } else {
        return isValid;
      }

    }

    function validDepDelay() {

      //Please remove Departure delay reasons for the Departure delay (ATD - STD).
      if (!!vm.flightInfoModel.atdDate && !!vm.flightInfoModel.atdTime &&
        !!vm.flightInfoModel.stdDate && !!vm.flightInfoModel.stdTime) {
        var mm = moment(vm.flightInfoModel.atdDate + " " + vm.flightInfoModel.atdTime, "DD/MM/YYYY HH:mm")
          .diff(moment(vm.flightInfoModel.stdDate + " " + vm.flightInfoModel.stdTime, "DD/MM/YYYY HH:mm"));
        var d = moment.duration(mm);
        var actualDepDelay = d.asMinutes();

        if ((actualDepDelay > 0) && ((actualDepDelay < vm.flightInfoModel.totalDelay && vm.flightInfoModel.totalDelay !== "") || (actualDepDelay < vm.flightInfoModel.totalDelay && vm.flightInfoModel.totalDelay !== "" && vm.flightInfoModel.totalDelay > 0))) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_15);
          return false;

        }
        else if (actualDepDelay > vm.flightInfoModel.totalDelay && vm.flightInfoModel.totalDelay !== "" && actualDepDelay > 0) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_16);
          return false;
        }
      }
      return true;
    }


    function dateValidDate(date) {
      var isValid = false;

      if (!!date) {
        var isValid = moment(date, 'DD/MM/YYYY', true).isValid();
      }
      return isValid;

    }

    function timeValidate(time) {
      var isValid = false;

      if (!!time) {
        var isValid = moment(time, 'HH:mm', true).isValid();
      }
      return isValid;
    }

    function setYesNoDropDownValuesOnUpdate(value) {
      if (value) {
        if (value.Val === "Yes") {
          return "Y";
        } else if (value.Val === "No") {
          return "N";
        } else {
          return null;
        }
      } else {
        return null;
      }
    }


    function calTotalDelay() {
      vm.totalOfDelays = 0;
      angular.forEach(vm.Delays, function (delay) {
        if (delay.delayMin) {

          if (isNaN(delay.delayMin)) {
            delay.delayMin = "";
          }
          else {
            vm.totalOfDelays = parseInt(vm.totalOfDelays) + parseInt(delay.delayMin);
          }
        }

      });
      vm.flightInfoModel.totalDelay = vm.totalOfDelays;
    }

    function loadDelayCodeDetails() {
      CommonMasterData.getDelayCodeDetails(function (response) {
        console.log(response);
        vm.delayCodeDetails = response.delayCodeAdaptDTOs;
      }, function () {
      });
    }

    vm.onChangeDelay = function () {
      calTotalDelay();
    };

    vm.colorChangeOnChange = function (elmId) {
      var main = document.getElementById(elmId);

      switch (elmId) {
        case "medlArrival":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.medlArrival) === null || vm.flightHandlingModel.medlArrival.Val === setYesNoDropDownValuesOnload(modalParams.medLArrival)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "medLDeparture":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.medLDeparture) === null || vm.flightHandlingModel.medLDeparture.Val === setYesNoDropDownValuesOnload(modalParams.medLDeparture)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "cabinCleaning":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.cabinCleaning) === null || vm.flightHandlingModel.cabinCleaning.Val === setYesNoDropDownValuesOnload(modalParams.cabinCleaning)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "waterService":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.waterService) === null || vm.flightHandlingModel.waterService.Val === setYesNoDropDownValuesOnload(modalParams.waterSvc)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "toiletService":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.toiletService) === null || vm.flightHandlingModel.toiletService.Val === setYesNoDropDownValuesOnload(modalParams.toiletSvc)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "towing":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.towing) === null || vm.flightHandlingModel.towing.Val === setYesNoDropDownValuesOnload(modalParams.towing)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;

        case "gpu":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.gpu) === null || vm.flightHandlingModel.gpu.Val === setYesNoDropDownValuesOnload(modalParams.gpu)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "acu":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.acu) === null || vm.flightHandlingModel.acu.Val === setYesNoDropDownValuesOnload(modalParams.acu)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "asu":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.asu) === null || vm.flightHandlingModel.asu.Val === setYesNoDropDownValuesOnload(modalParams.asu)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "aerobridge":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.aerobridge) === null || vm.flightHandlingModel.aerobridge.Val === setYesNoDropDownValuesOnload(modalParams.aeroBridge)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "fireBirgade":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.fireBirgade) === null || vm.flightHandlingModel.fireBirgade.Val === setYesNoDropDownValuesOnload(modalParams.fireBrigade)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "engTechnical":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.engTechnical) === null || vm.flightHandlingModel.engTechnical.Val === setYesNoDropDownValuesOnload(modalParams.engTecSvc)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "deIcing":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.deIcing) === null || vm.flightHandlingModel.deIcing.Val === setYesNoDropDownValuesOnload(modalParams.deicing)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "paxBus":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.paxBus) === null || vm.flightHandlingModel.paxBus.Val === setYesNoDropDownValuesOnload(modalParams.paxBus)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "paxSteps":
          if (setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.paxSteps) === null || vm.flightHandlingModel.paxSteps.Val === setYesNoDropDownValuesOnload(modalParams.paxSteps)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "fine":
          if (setYesNoDropDownValuesOnUpdate(vm.addlInfo.fine) === null || vm.addlInfo.fine.Val === setYesNoDropDownValuesOnload(modalParams.fine)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;
        case "bmeService":
          if (setYesNoDropDownValuesOnUpdate(vm.addlInfo.bmeService) === null || vm.addlInfo.bmeService.Val === setYesNoDropDownValuesOnload(modalParams.bmeService)) {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = '#8097a2';
          } else {
            main.childNodes[0].childNodes[2].childNodes[3].childNodes[1].style.color = "black";
          }
          break;


      }


    }

    vm.onTimeChange = function (id, val) {
      var inputField = document.getElementById(id);
      console.log(inputField.value);
      if (!angular.isUndefined(val)) {
        if (23 < parseInt(val.split(":")[0])) {
          inputField.value = "23:" + inputField.value.split(":")[1];
        }
      }
    }


    vm.onTotalGoShowAmtChange = function () {
      vm.paxHandlingModel.totalGoShowAmount = parseFloat(vm.paxHandlingModel.goShowAmountAdultChild) + parseFloat(vm.paxHandlingModel.goShowAmountInfant);
      vm.onTotalAcncilaryChange();
    }

    vm.onEBTTotalChange = function () {
      vm.paxHandlingModel.ebtTotalAmount = parseFloat(vm.paxHandlingModel.ebRevenue) + parseFloat(vm.paxHandlingModel.AdditionalBagRevenue) + parseFloat(vm.paxHandlingModel.ebAdditionalBagServiceCharge);
      vm.onTotalAcncilaryChange();
    }

    vm.onTotalAcncilaryChange = function () {
      vm.paxHandlingModel.totalAncillary = parseFloat(vm.paxHandlingModel.totalGoShowAmount) + parseFloat(vm.paxHandlingModel.ebtTotalAmount) + parseFloat(vm.paxHandlingModel.whcrAmount) + parseFloat(vm.paxHandlingModel.tvLedAmount) + parseFloat(vm.paxHandlingModel.seatAmt);
    }

    function paxTbale1Obj() {
      var rowDate = {"value1": '', "value2": '', "value3": ''};
      return rowDate;
    };

    function paxTbale2Obj() {
      var rowDate = {"value1": '', "value2": '', "value3": ''};
      return rowDate;
    };

    function paxTbale3Obj() {
      var rowDate = {"value1": '', "value2": '', "value3": ''};
      return rowDate;
    };

    function paxTbale4Obj() {
      var rowDate = {"value1": '', "value2": '', "value3": ''};
      return rowDate;
    };

    function addNewRowToTable(number) {

      switch (number) {
        case 1:
          var data = paxTbale1Obj();
          if (vm.paxtable1.length > 24) {
            vm.enablePaxTable1AddBtn = false;
          } else {
            vm.paxtable1.push(data);
          }
          break;
        case 2:
          var data = paxTbale2Obj();
          if (vm.paxtable2.length > 24) {
            vm.enablePaxTable2AddBtn = false;
          } else {
            vm.paxtable2.push(data);
          }
          break;
        case 3:
          var data = paxTbale3Obj();
          if (vm.paxtable3.length > 24) {
            vm.enablePaxTable3AddBtn = false;
          } else {
            vm.paxtable3.push(data);
          }
          break;
        case 4:
          var data = paxTbale4Obj();
          if (vm.paxtable4.length > 24) {
            vm.enablePaxTable4AddBtn = false;
          } else {
            vm.paxtable4.push(data);
          }
          break;
        default:
          console.log("No matched table");
      }

    }

    //field validations

    vm.OnFocusOutInfant = function (elmId) {
      if (vm.flightInfoModel.actAdult + 20 < vm.paxHandlingModel.infantCount) {
        vm.paxHandlingModel.infantCount = vm.flightInfoModel.actInfant;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.paxHandlingModel.infantCount;
        }
      }
    }

    vm.OnFocusOutArrivalPax = function (elmId) {
      if (vm.modalParam.aircraftCapacity + 3 < vm.paxHandlingModel.arrivalPax) {
        vm.paxHandlingModel.arrivalPax = vm.modalParam.arrivalPax;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.arrivalPax;
        }
      }
    }

    vm.OnFocusOutArrivalCargo = function (elmId) {
      if (99999 < vm.paxHandlingModel.arrivalCargo) {
        vm.paxHandlingModel.arrivalCargo = vm.modalParam.arrivalCargoKgs;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.arrivalCargoKgs;
        }
      }
    }

    vm.OnFocusOutDepartureCargo = function (elmId) {
      if (99999 < vm.paxHandlingModel.departureCargo) {
        vm.paxHandlingModel.departureCargo = vm.modalParam.departureCargoKgs;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.departureCargoKgs;
        }
      }
    }

    vm.OnFocusOutDNBOB = function (elmId) {
      if (99 < vm.paxHandlingModel.dnbOverbooking) {
        vm.paxHandlingModel.dnbOverbooking = vm.modalParam.bnbOverBooking;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.bnbOverBooking;
        }
      }
    }

    vm.OnFocusOutGateNoShow = function (elmId) {
      if (99 < vm.paxHandlingModel.gateNoShow) {
        vm.paxHandlingModel.gateNoShow = vm.modalParam.gateNoShow;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.gateNoShow;
        }
      }
    }

    vm.OnFocusOutCounterRef = function (elmId) {
      if (25 < vm.paxHandlingModel.counterRefusalCount) {
        vm.paxHandlingModel.counterRefusalCount = parseInt(vm.modalParam.counterRefusal);
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =parseInt(vm.modalParam.counterRefusal);;
        }
      }
    }

    vm.OnFocusOutTotalAcceptedOB = function (elmId) {
      if (vm.modalParam.aircraftCapacity + 3 < vm.paxHandlingModel.totalAcceptedOB) {
        vm.paxHandlingModel.totalAcceptedOB = vm.modalParam.totalAcceptedOnBoard;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.totalAcceptedOnBoard;
        }
      }
    }

    vm.OnFocusOutNorecCount = function (elmId) {
      if (25 < vm.paxHandlingModel.norecCount) {
        vm.paxHandlingModel.norecCount = parseInt(vm.modalParam.noRecCount);
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value = parseInt(vm.modalParam.noRecCount);
        }
      }
    }

    vm.OnFocusOutVisaChangePax = function (elmId) {
      if (vm.modalParam.aircraftCapacity + 3 < vm.paxHandlingModel.visaChangePax) {
        vm.paxHandlingModel.visaChangePax = vm.modalParam.visaChangePax;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.visaChangePax;
        }
      }
    }

    vm.OnFocusOutGoShowAdultChild = function (elmId) {
      if (25 < vm.paxHandlingModel.goShowAdultChild) {
        vm.paxHandlingModel.goShowAdultChild = parseInt(vm.modalParam.goShowAdultChild);
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value = parseInt(vm.modalParam.goShowAdultChild);
        }
      }
    }

    vm.OnFocusOutGoShowINF = function (elmId) {
      if (20 < vm.paxHandlingModel.goShowInfant) {
        vm.paxHandlingModel.goShowInfant = vm.modalParam.goShowInfra;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.goShowInfra;
        }
      }
    }

    vm.OnFocusOutEBVoucherIssued = function (elmId) {
      if (999 < vm.paxHandlingModel.ebVoucherIssued) {
        vm.paxHandlingModel.ebVoucherIssued = vm.modalParam.ebVoucherIssued;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.ebVoucherIssued;
        }
      }
    }

    vm.OnFocusOutGateHandbagCollection = function (elmId) {
      if (999 < vm.paxHandlingModel.gateHandbagCollection) {
        vm.paxHandlingModel.gateHandbagCollection = vm.modalParam.gateHandbagCollection;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.gateHandbagCollection;
        }
      }
    }

    vm.OnFocusOutEBWeight = function (elmId) {
      if (9999 < vm.paxHandlingModel.ebWeight) {
        vm.paxHandlingModel.ebWeight = vm.modalParam.ebWeightKg;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.ebWeightKg;
        }
      }
    }

    vm.OnFocusOutWHCRDeparture = function (elmId) {
      if (99 < vm.paxHandlingModel.wchrDeparture) {
        vm.paxHandlingModel.wchrDeparture = vm.modalParam.wchrDeparture;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.wchrDeparture;
        }
      }
    }

    vm.OnFocusOutAcceptedTVLED = function (elmId) {
      if (99 < vm.paxHandlingModel.acceptedTvLed) {
        vm.paxHandlingModel.acceptedTvLed = vm.modalParam.acptTvLed;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.acptTvLed;
        }
      }
    }

    vm.OnFocusOutWHCRArrival = function (elmId) {

      if (99 < vm.flightHandlingModel.wheelChairArrival) {
        vm.flightHandlingModel.wheelChairArrival = vm.modalParam.wchrArrival;
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value =vm.modalParam.wchrArrival;
        }
      }
    }

    vm.OnFocusOutInNumberField = function (elmId,modalParamVal) {
      var inputField = document.getElementById(elmId);
      if(inputField.value == null){
        inputField.value = modalParamVal;
      }
      else if (inputField.value == '') {
        inputField.value =modalParamVal;
      }
    }

    vm.OnFocusOutSeatsCount = function (elmId) {
      if (25 < vm.paxHandlingModel.seatS) {
        vm.paxHandlingModel.seatS = parseInt(vm.modalParam.seat);
      }else{
        var inputField = document.getElementById(elmId);
        if (inputField.value == '') {
          inputField.value = parseInt(vm.modalParam.seat);
        }
      }
    }

    vm.addNewTableRow = function (number) {
      addNewRowToTable(number);
    };

    vm.OnPaxTableValueChange = function (table) {
      genarateFieldsForPaxTables(table);
    }

    function genarateFieldsForPaxTables(table) {

      if (table == 0 || table == 1) {
        for (var i = ((vm.paxtable1 == null) ? 0 : (vm.paxtable1.length)); i < vm.paxHandlingModel.goShowAdultChild; i++) {
          addNewRowToTable(1);
        }
        if (vm.paxHandlingModel.goShowRef != null) {
          for (var i = 0; i < vm.paxHandlingModel.goShowRef.length; i++) {
            if (i < vm.paxtable1.length) {
              vm.paxtable1[i].value1 = vm.paxHandlingModel.goShowRef[i].value1;
              vm.paxtable1[i].value2 = vm.paxHandlingModel.goShowRef[i].value2;
              vm.paxtable1[i].value3 = vm.paxHandlingModel.goShowRef[i].value3;
            }
          }
        }
        if (vm.paxtable1.length > vm.paxHandlingModel.goShowAdultChild) {
          vm.paxtable1.splice(vm.paxHandlingModel.goShowAdultChild, vm.paxtable1.length - vm.paxHandlingModel.goShowAdultChild);
        }
      }

//2
      if (table == 0 || table == 2) {
        for (var i = ((vm.paxtable2 == null) ? 0 : (vm.paxtable2.length)); i < vm.paxHandlingModel.seatS; i++) {
          addNewRowToTable(2);
        }
        if (vm.paxHandlingModel.seatRef != null) {
          for (var i = 0; i < vm.paxHandlingModel.seatRef.length; i++) {
            if (i < vm.paxtable2.length) {
              vm.paxtable2[i].value1 = vm.paxHandlingModel.seatRef[i].value1;
              vm.paxtable2[i].value2 = vm.paxHandlingModel.seatRef[i].value2;
              vm.paxtable2[i].value3 = vm.paxHandlingModel.seatRef[i].value3;
            }
          }
        }
        if (vm.paxtable2.length > vm.paxHandlingModel.seatS) {
          vm.paxtable2.splice(vm.paxHandlingModel.seatS, vm.paxtable2.length - vm.paxHandlingModel.seatS)
        }
      }


//3
      if (table == 0 || table == 3) {
        for (var i = ((vm.paxtable3 == null) ? 0 : (vm.paxtable3.length)); i < vm.paxHandlingModel.counterRefusalCount; i++) {
          addNewRowToTable(3);
        }
        if (vm.paxHandlingModel.counterRefusalRef != null) {
          for (var i = 0; i < vm.paxHandlingModel.counterRefusalRef.length; i++) {
            if (i < vm.paxtable3.length) {
              vm.paxtable3[i].value1 = vm.paxHandlingModel.counterRefusalRef[i].value1;
              vm.paxtable3[i].value2 = vm.paxHandlingModel.counterRefusalRef[i].value2;
              vm.paxtable3[i].value3 = vm.paxHandlingModel.counterRefusalRef[i].value3;
            }
          }
        }
        if (vm.paxtable3.length > vm.paxHandlingModel.counterRefusalCount) {
          vm.paxtable3.splice(vm.paxHandlingModel.counterRefusalCount, vm.paxtable3.length - vm.paxHandlingModel.counterRefusalCount)
        }
      }


//4
      if (table == 0 || table == 4) {
        for (var i = ((vm.paxtable4 == null) ? 0 : (vm.paxtable4.length)); i < vm.paxHandlingModel.norecCount; i++) {
          addNewRowToTable(4);
        }
        if (vm.paxHandlingModel.norecRef != null) {
          for (var i = 0; i < vm.paxHandlingModel.norecRef.length; i++) {
            if (i < vm.paxtable4.length) {
              vm.paxtable4[i].value1 = vm.paxHandlingModel.norecRef[i].value1;
              vm.paxtable4[i].value2 = vm.paxHandlingModel.norecRef[i].value2;
              vm.paxtable4[i].value3 = vm.paxHandlingModel.norecRef[i].value3;
            }
          }
        }
        if (vm.paxtable4.length > vm.paxHandlingModel.norecCount) {
          vm.paxtable4.splice(vm.paxHandlingModel.norecCount, vm.paxtable4.length - vm.paxHandlingModel.norecCount)
        }
      }


    }



    vm.updateData = function (formNo) {
      if (formNo === 1) {
        if (!vm.flightInfoModelForm.$valid) {
          return;
        }
      } else if (formNo === 2) {
        if (!vm.flightHandlingModelForm.$valid) {
          return;
        }

      } else if (formNo === 3) {
        if (!vm.paxHandlingModelForm.$valid) {
          return;
        }
      }else if (formNo === 4) {
        if (!vm.AdditionalInfo.$valid) {
          return;
        }
      }

      var isValidFields = validateFields();
      var isValid = validateMovementInfo();
      console.log("isValid :", isValid);
      if (isValidFields && isValid) {
        updateModalParam();
        StationFlightHandlingService.updateStationFlightHandlingData(modalParams,
          function (updatedResult) {
            if (updatedResult.errors == null) {
              MessageService.success(MessageService.MESSAGES.COMMON.SUCCESS_SAVED);
              $scope.$emit("OnSaveSFH");
              vm.closePopUp();
            } else {
              MessageService.error(updatedResult.errors);
            }

          }, function (error) {
            MessageService.error(error.msg);
          });
      }

    };

    function updateModalParam() {

        modalParams.estDepartureDate = vm.flightInfoModel.rstdDate + " " + vm.flightInfoModel.rstdTime,
        modalParams.estDepartureDateTime = vm.flightInfoModel.rstdTime,
        modalParams.estArrivalDate = vm.flightInfoModel.rstaDate + " " + vm.flightInfoModel.rstaTime,
        modalParams.estArrivalDateTime = vm.flightInfoModel.rstaTime,
        modalParams.groundTime = vm.flightInfoModel.groundTime,
        modalParams.gate = vm.flightInfoModel.bayGate,
        modalParams.delay1 = ((vm.Delays[0].delayMin !== null) ? vm.Delays[0].delayMin : modalParams.delay1),
        modalParams.delay2 = ((vm.Delays[1].delayMin !== null) ? vm.Delays[1].delayMin : modalParams.delay1),
        modalParams.delay3 = ((vm.Delays[2].delayMin !== null) ? vm.Delays[2].delayMin : modalParams.delay1),
        modalParams.delay4 = ((vm.Delays[3].delayMin !== null) ? vm.Delays[3].delayMin : modalParams.delay1),
        modalParams.delay1Code = getDelayCodeForUpdate(0) === " " ? null : getDelayCodeForUpdate(0),
        modalParams.delay2Code = getDelayCodeForUpdate(1) === " " ? null : getDelayCodeForUpdate(1),
        modalParams.delay3Code = getDelayCodeForUpdate(2) === " " ? null : getDelayCodeForUpdate(2),
        modalParams.delay4Code = getDelayCodeForUpdate(3) === " " ? null : getDelayCodeForUpdate(3),
        modalParams.totalDelay = vm.totalOfDelays,
        modalParams.thirdPartyGroundHandler = vm.flightInfoModel.thirdPartyGroundHandler,
        modalParams.remarks = vm.flightInfoModel.remarks,

        modalParams.lastPaxDissEmbarked = vm.flightHandlingModel.lastPasDisembarked,
        modalParams.cleaningStart = vm.flightHandlingModel.cleaningStart,
        modalParams.cleaningEnd = vm.flightHandlingModel.CleaningEnd,
        modalParams.cockpitCrewReporting = vm.flightHandlingModel.cockpitCrewReporting,
        modalParams.cabinCrewReporting = vm.flightHandlingModel.cabinCrewReporting,
        modalParams.boardingClearance = vm.flightHandlingModel.boardingClearance,
        modalParams.firstPaxBrd = vm.flightHandlingModel.firstPaxBoarded,
        modalParams.lastPaxBrd = vm.flightHandlingModel.lastPaxBoarded,
        modalParams.doorClosed = vm.flightHandlingModel.doorsClosed,
        modalParams.holdsClosed = vm.flightHandlingModel.holdsClosed,
        modalParams.wchrArrival = vm.flightHandlingModel.wheelChairArrival,
        modalParams.medLArrival = vm.flightHandlingModel.medlArrival,
        modalParams.medLDeparture = vm.flightHandlingModel.medLDeparture,
        modalParams.cabinCleaning = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.cabinCleaning),
        modalParams.waterSvc = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.waterService),
        modalParams.toiletSvc = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.toiletService),
        modalParams.towing = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.towing),
        modalParams.gpu = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.gpu),
        modalParams.asu = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.asu),
        modalParams.acu = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.acu),
        modalParams.aeroBridge = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.aerobridge),
        modalParams.fireBrigade = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.fireBirgade),
        modalParams.engTecSvc = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.engTechnical),
        modalParams.deicing = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.deIcing),
        modalParams.paxBus = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.paxBus),
        modalParams.paxSteps = setYesNoDropDownValuesOnUpdate(vm.flightHandlingModel.paxSteps),
        modalParams.additionalSvcComment = vm.flightHandlingModel.additionalComment,

        modalParams.goShowAdultChild = vm.paxHandlingModel.goShowAdultChild,
        modalParams.goShowAdultChildAmt = vm.paxHandlingModel.goShowAmountAdultChild,
        modalParams.goShowInfra = vm.paxHandlingModel.goShowInfant,
        modalParams.goShowInfraAmt = vm.paxHandlingModel.goShowAmountInfant,
        modalParams.totalGoShowAmount = vm.paxHandlingModel.totalGoShowAmount,
        modalParams.arrivalPax = vm.paxHandlingModel.arrivalPax,
        modalParams.arrivalCargoKgs = vm.paxHandlingModel.arrivalCargo,
        modalParams.departureCargoKgs = vm.paxHandlingModel.departureCargo,
        modalParams.totalAcceptedOnBoard = vm.paxHandlingModel.totalAcceptedOB,
        modalParams.infCount = vm.paxHandlingModel.infantCount,
        modalParams.bnbOverBooking = vm.paxHandlingModel.dnbOverbooking,
        modalParams.gateNoShow = vm.paxHandlingModel.gateNoShow,
        modalParams.visaChangePax = vm.paxHandlingModel.visaChangePax,
        modalParams.ebVoucherIssued = vm.paxHandlingModel.ebVoucherIssued,
        modalParams.gateHandbagCollection = vm.paxHandlingModel.gateHandbagCollection,
        modalParams.ebWeightKg = vm.paxHandlingModel.ebWeight,
        modalParams.ebRevenue = vm.paxHandlingModel.ebRevenue,
        modalParams.addBagRevenue = vm.paxHandlingModel.AdditionalBagRevenue,
        modalParams.ebAddSrvCharge = vm.paxHandlingModel.ebAdditionalBagServiceCharge,
        modalParams.ebtTotal = vm.paxHandlingModel.ebtTotalAmount,
        modalParams.wchrDeparture = vm.paxHandlingModel.wchrDeparture,
        modalParams.wchrAmount = vm.paxHandlingModel.whcrAmount,
        modalParams.seat = vm.paxHandlingModel.seatS,
        modalParams.seatsAmount = vm.paxHandlingModel.seatAmt,
        modalParams.seatsPnrName = vm.paxHandlingModel.seatsPnrName,
        modalParams.acptTvLed = vm.paxHandlingModel.acceptedTvLed,
        modalParams.tvLedAmount = vm.paxHandlingModel.tvLedAmount,
        modalParams.totalAncillary = vm.paxHandlingModel.totalAncillary,
        modalParams.pendingBalance = vm.paxHandlingModel.pendingBalance,
        modalParams.counterRefusal = vm.paxHandlingModel.counterRefusalCount,
        modalParams.noRecCount = vm.paxHandlingModel.norecCount,
          modalParams.noOfCodesharePax = vm.paxHandlingModel.noOfCodesharePax,

        modalParams.remarksPax = vm.paxHandlingModel.remarks,

        modalParams.goShowRef = vm.paxtable1,
        modalParams.seatRef = vm.paxtable2,
        modalParams.counterRefusalRef = vm.paxtable3,
        modalParams.norecRef = vm.paxtable4

        modalParams.bmeService = setYesNoDropDownValuesOnUpdate(vm.addlInfo.bmeService),
        modalParams.lbBaggagePCS = vm.addlInfo.lbBaggagePCS ,
        modalParams.lbBaggageWeight = vm.addlInfo.lbBaggagePCS == 0? 0: vm.addlInfo.lbBaggageWeight,
        modalParams.lbBaggageReason = vm.addlInfo.lbBaggagePCS == 0? '':vm.addlInfo.lbBaggageReason ,
        modalParams.ovszdBaggage = vm.addlInfo.ovszdBaggage,
        modalParams.sportEquipCount = vm.addlInfo.sportEquipCount,
        modalParams.sportEquipDesc = vm.addlInfo.sportEquipDesc
        modalParams.fine = setYesNoDropDownValuesOnUpdate(vm.addlInfo.fine),
        modalParams.inadPax = vm.addlInfo.INADPax,
        modalParams.paxCost = vm.addlInfo.INADPaxCost

    }

    function getDelayCodeForUpdate(no) {
      var outPut = null;
      if (vm.Delays[no].delayCode === null) {
        return null;
      } else {
        if (angular.isUndefined(vm.Delays[no].delayCode.delayCode)) {
          return vm.Delays[no].delayCode;
        } else {
          return vm.Delays[no].delayCode.delayCode;
        }
      }
    }

    //auditlog


    function loadAuditData() {
      StationFlightHandlingService.getAuditData(modalParams.flightLegId,
        function (Data) {
          vm.auditLog = Data;

        }, function (error) {
          MessageService.error(error);
        });

    }

    //auditlog


  }

  $(window).resize(function () {
    if ($(".tabbed-view-container").height() < 40) {
      $(".tabbed-view-container").css("height", 40);
    }
    var height = Math.max($("header").height() + $(".tabbed-view-container").height(), 110) + "px";
    $(".flight-watch-view .canvas").css("top", height);
  });

}());


